import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../../../store/app-state";
import {
  CompanyDataContainer,
  CompanyDescriptionContainer,
  SectionContainer,
} from "./company-section.styled";
import LabelInput from "./components/label-input/label-input";
import useRootTranslation from "../../../../../hooks/use-root-translation";
import { LanguageSelect } from "./components/language-select";
import { useCallback, useMemo } from "react";
import { changeCompanyCurrency, changeCompanyLanguage } from "../../../../../store/application/application-actions";
import Modal from "../../../../../components/modal/modal";
import LoadingSpinner from "../../../../../components/loading-spinner";
import { Text } from "../../../../../components/common";
import { useTheme } from "styled-components";
import { CurrencySelect } from "./components/currency-select";

const modalTalent = document.getElementById("modal-talent");

const CompanySection: React.FC = () => {
  const { root, t } = useRootTranslation(
    "company-profile.company-section",
    "private-home-page"
  );
  const { user } = useSelector((state: AppState) => state.authState);
  const dispatch = useDispatch();
  const changeLanguage = useCallback(
    (language: string) => {
      if (user?.corporate.id) {
        dispatch(changeCompanyLanguage(language, user?.corporate.id));
      }
    },
    [dispatch, user]
  );
  const changeCurrency = useCallback(
    (language: string) => {
      if (user?.corporate.id) {
        dispatch(changeCompanyCurrency(language, user?.corporate.id));
      }
    },
    [dispatch, user]
  );
  const theme = useTheme();
  const { companyLanguage, companyCurrency } = useSelector(
    (state: AppState) => state.applicationState
  );
  
  const language = useMemo(() => {
    return user?.corporate.language?.code ?? "pt-BR";
  }, [user]);

  const currency = useMemo(() => {
    return user?.corporate.currency ?? "BRL";
  }, [user]);

  return (
    <SectionContainer id="company-infos">
      <CompanyDataContainer>
        <LabelInput
          label={root("company-name")}
          placeholder={root("company-name").toLowerCase()}
          value={user?.corporate.name}
          image={user?.corporate.image}
        />
        <LabelInput
          label={root("company-size")}
          placeholder={root("company-size").toLowerCase()}
          value={t(
            `onboarding.company.employeesRange.${user?.corporate.size_range}`,
            { defaultValue: user?.corporate.size_range }
          )}
        />
        <LabelInput
          label={root("company-site")}
          placeholder="www.site.com.br"
          value={user?.corporate.site}
        />
        <LabelInput
          label={root("company-location")}
          placeholder={root("company-location").toLowerCase()}
          value={user?.corporate.location}
        />
        <LanguageSelect
          label={root("company-language")}
          language={language}
          onChange={(language) => changeLanguage(language)}
        />
        <CurrencySelect
          label={root("company-currency")}
          currency={currency}
          onChange={(currency) => changeCurrency(currency)}
        />
      </CompanyDataContainer>
      <CompanyDescriptionContainer>
        <LabelInput
          label={root("company-description")}
          placeholder=""
          value={user?.corporate.description}
          isDescription={true}
        />
      </CompanyDescriptionContainer>
      <Modal
        width={500}
        target={modalTalent}
        isShown={companyLanguage.loading || companyCurrency.loading}
        toggle={() => {}}
        showCloseButton={false}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "1rem",
          }}
        >
          <LoadingSpinner />
          <Text color={theme.colors.primaryBlue.main}>
            {root("company-info-change")}
          </Text>
        </div>
      </Modal>
    </SectionContainer>
  );
};

export default CompanySection;
